import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
    cardTypeSelectorButtonGroup: (props) => ({
        position: 'relative',
        display: 'flex',
        width: '100%',
        height: '72px',
        // ButtonGroup styling for twoLine variant
        '& .MuiButtonGroup-grouped': {
            // Reset all ButtonGroup specific styling
            margin: '0 4px',
            border: '2px solid #9D9D9D',
            borderRadius: '5px !important', // Force border radius on all corners
            // Override the negative margin that ButtonGroup applies
            '&:not(:first-child)': {
                marginLeft: '8px',
                borderLeftColor: '#9D9D9D',
                borderLeft: '2px solid #9D9D9D',
            },
            '&:not(:last-child)': {
                borderRightColor: '#9D9D9D',
                borderRight: '2px solid #9D9D9D',
            },
        },
        ...(props.isFixedWidth
            ? {
                  maxWidth: 245,
                  [theme.breakpoints.up(375)]: {
                      maxWidth: 300,
                  },
                  [theme.breakpoints.up(425)]: {
                      maxWidth: 340,
                  },
                  [theme.breakpoints.up(1150)]: {
                      maxWidth: 420,
                  },
              }
            : {
                  maxWidth: '100%',
              }),
    }),
    cardTypeSelectorButton: {
        width: '100%',
        textTransform: 'none',
        backgroundColor: 'white',
        color: '#4F4F4F',
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: '1.25rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '72px',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#F8F8F8',
        },
        '&.selected': {
            backgroundColor: '#FCEDFF',
            border: `2px solid ${theme.palette.primary.main} !important`,
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: '#FCEDFF',
            },
            '& svg': {
                filter: 'none',
            },
        },
        [theme.breakpoints.up('sm')]: {
            padding: '5px 30px',
            fontSize: '1.25rem',
        },
    },
    twoLineContentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    subText: {
        fontSize: '12px',
        fontWeight: 'normal',
        marginTop: '0.1rem',
        textAlign: 'center',
        display: 'block',
        width: '100%',
        lineHeight: '1rem',
        letterSpacing: 'normal',
        whiteSpace: 'nowrap',
    },
}))

const CardTypeSelector = ({
    options,
    selectedOption,
    handleSelection,
    buttonGroupClassOverride,
    isFixedWidth = false,
}) => {
    const classes = useStyles({ isFixedWidth })

    return (
        <ButtonGroup
            className={`${classes.cardTypeSelectorButtonGroup} ${
                buttonGroupClassOverride || ''
            }`}
            variant="text"
            disableElevation
            disableRipple
        >
            {options.map((option) => (
                <Button
                    key={option.value}
                    className={`${classes.cardTypeSelectorButton} ${
                        selectedOption === option.value ? 'selected' : ''
                    }`}
                    onClick={() => {
                        handleSelection(option.value)
                    }}
                >
                    <div className={classes.twoLineContentWrapper}>
                        <div style={{ fontSize: '16px' }}>{option.label}</div>
                        {option.secondaryText && (
                            <div className={classes.subText}>
                                {option.secondaryText}
                            </div>
                        )}
                    </div>
                </Button>
            ))}
        </ButtonGroup>
    )
}

CardTypeSelector.propTypes = {
    options: PropTypes.array.isRequired,
    selectedOption: PropTypes.any.isRequired,
    handleSelection: PropTypes.func.isRequired,
    buttonGroupClassOverride: PropTypes.string,
    isFixedWidth: PropTypes.bool,
}

export default CardTypeSelector
